module.exports = __webpack_public_path__ + "static/mr-concert-performance-27-2fc3bfc1bf8e105cfb89118329e82680.jpg";